/* @jsx h */
import { labels } from '../config';

const Pagination = ({
  pagination,
  pageBrowserRange,
  allResultCount,
  handlePaginationClick,
}) => {
  if (allResultCount === 0) {
    return '';
  }

  let maximumNumberOfLinks = 5;
  if (maximumNumberOfLinks > pagination.numberOfPages) {
    maximumNumberOfLinks = pagination.numberOfPages;
  }
  const delta = Math.floor(maximumNumberOfLinks / 2);
  let displayRangeStart = pagination.current - delta;
  let displayRangeEnd =
    pagination.current + delta - (maximumNumberOfLinks % 2 === 0 ? 1 : 0);
  if (displayRangeStart < 1) {
    displayRangeEnd -= displayRangeStart - 1;
  }
  if (displayRangeEnd > pagination.numberOfPages) {
    displayRangeStart -= displayRangeEnd - pagination.numberOfPages;
  }
  displayRangeStart = parseInt(Math.max(displayRangeStart, 1), 10);
  displayRangeEnd = parseInt(
    Math.min(displayRangeEnd, pagination.numberOfPages),
    10
  );

  const pages = [];
  for (let i = displayRangeStart; i <= displayRangeEnd; i++) {
    pages.push({
      number: i,
      isCurrent: i === pagination.current,
    });
  }
  let nextPage;
  if (pagination.current < pagination.numberOfPages) {
    nextPage = pagination.current + 1;
  }
  let previousPage;
  if (pagination.current > 1) {
    previousPage = pagination.current - 1;
  }

  return (
    <div className="nav-pagination-wrapper">
      <span
        className="nav-pagination-state"
        dangerouslySetInnerHTML={{
          __html: labels.results.range
            .replace('%s', pageBrowserRange.from)
            .replace('%s', pageBrowserRange.to)
            .replace('%s', allResultCount),
        }}
      />

      {pagination.numberOfPages > 1 && (
        <nav
          className="nav-pagination"
          aria-label={labels.pagination.pagination}
        >
          <ol className="nav-pagination__list">
            <li className="nav-pagination__item">
              <a
                href=""
                className="nav-pagination__link nav-pagination__link--prev"
                tabindex={previousPage ? false : -1}
                aria-disabled={previousPage ? 'false' : 'true'}
                data-page={previousPage}
                onClick={handlePaginationClick}
              >
                <span class="icon icon--chevron-up icon--turned-ccw-90°">
                  <svg
                    class="icon__svg"
                    focusable="false"
                    role="img"
                    aria-hidden="true"
                  >
                    <use href="#icon-chevron-up" />
                  </svg>
                  <span class="sr-only">{labels.pagination.prev}</span>
                </span>
              </a>
            </li>
            {pages.map(page =>
              page.isCurrent ? (
                <li className="nav-pagination__item nav-pagination__item--current">
                  <span aria-current="page" data-page={page.number}>
                    <span className="sr-only">
                      {labels.pagination.currentPage}
                    </span>
                    {page.number}
                  </span>
                </li>
              ) : (
                <li className="nav-pagination__item">
                  <a
                    href=""
                    className="nav-pagination__link"
                    data-page={page.number}
                    onClick={handlePaginationClick}
                  >
                    <span className="sr-only">{labels.pagination.page}</span>
                    {page.number}
                  </a>
                </li>
              )
            )}
            <li className="nav-pagination__item">
              <a
                href=""
                className="nav-pagination__link nav-pagination__link--next"
                tabindex={nextPage ? false : -1}
                aria-disabled={nextPage ? 'false' : 'true'}
                data-page={nextPage}
                onClick={handlePaginationClick}
              >
                <span class="icon icon--chevron-down icon--turned-ccw-90°">
                  <svg
                    class="icon__svg"
                    focusable="false"
                    role="img"
                    aria-hidden="true"
                  >
                    <use href="#icon-chevron-down" />
                  </svg>
                  <span class="sr-only">{labels.pagination.next}</span>
                </span>
              </a>
            </li>
          </ol>
        </nav>
      )}
    </div>
  );
};

export default Pagination;
